import { Browser as r } from "./browser.js";
import { Mobile as m } from "./mobile.js";
import { Terminal1 as o } from "./terminal-1.js";
import { Terminal2 as i } from "./terminal-2.js";
import { Terminal3 as e } from "./terminal-3.js";
import { Webcam as t } from "./webcam.js";
const s = {
  Browser: r,
  Mobile: m,
  Terminal1: o,
  Terminal2: i,
  Terminal3: e,
  Webcam: t
};
export {
  s as Devices24
};
